import { render, staticRenderFns } from "./OrderHistory.vue?vue&type=template&id=3f2f2994&"
import script from "./OrderHistory.vue?vue&type=script&lang=js&"
export * from "./OrderHistory.vue?vue&type=script&lang=js&"
import style0 from "./OrderHistory.vue?vue&type=style&index=0&id=3f2f2994&prod&lang=scss&"
import style1 from "./OrderHistory.vue?vue&type=style&index=1&id=3f2f2994&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports